import React from 'react';
import { Col, Form } from 'react-bootstrap';

// Name
const NameInput = ({ formFound, values, handleInputChange }) => {
  return (
    <Col lg={4} xs={12} className="mb-3">
      <Form.Group controlId={'validationCustom'}>
        <Form.Label>{formFound?.name?.name + ' *'}</Form.Label>
        <Form.Control
          name="name"
          type="text"
          minLength={2}
          maxLength={30}
          autoComplete="off"
          required
          placeholder={formFound?.name?.placeholder}
          onChange={handleInputChange}
          isValid={values.name?.length > 2}
          isInvalid={values.name?.length > 0 && values.name?.length <= 2}
        />
        <Form.Control.Feedback type="invalid">
          {formFound?.name?.name} mínimo 3 caracteres
        </Form.Control.Feedback>
      </Form.Group>
    </Col>
  );
};

export default NameInput;